// src/components/steps/Step1Auth.tsx

import { Organization } from 'lib/types'
import { useForm } from 'react-hook-form'

type Props = {
  onNext: (data: { org: Organization | null }) => void
  goBack: () => void
  data: {
    org: Organization | null
  }
}

export default function Step1Auth({ onNext, goBack, data }: Props) {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      mapId: data?.org?.mappedin?.mapId || '',
      apiKey: data?.org?.mappedin?.key || '',
      apiSecret: data?.org?.mappedin?.secret || '',
    },
  })

  const onSubmit = async (data: any) => {
    try {
      const res = await fetch('https://app.mappedin.com/api/api-key/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key: data.apiKey, secret: data.apiSecret }),
      })

      if (!res.ok) {
        throw new Error('Failed to authenticate with Mappedin API')
      }

      const json = await res.json()
      onNext({ accessToken: json.access_token, ...data })
    } catch (err: any) {
      alert(`Error: ${err.message}`)
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div>
        <h2 style={{ marginBottom: '0.5rem' }}>Step 1: Mappedin Authentication</h2>
        <p style={{ fontSize: '0.95rem', color: '#555' }}>To use the Mappedin integration, you’ll need:</p>
        <ul style={{ paddingLeft: '1.2rem', fontSize: '0.95rem', color: '#444' }}>
          <li>
            <strong>Map ID</strong> — found in your Mappedin portal. Login and select your venue. Copy the last route
            parameter in the url. Ex: https://app.mappedin.com/editor/edit/<strong>ABC-123-YOUR-MAP-ID</strong>
          </li>
          <li>
            <strong>API Key & Secret</strong> — Generated within MappedIn Developer Portal
          </li>
        </ul>
        <p style={{ fontSize: '0.9rem', marginTop: '1rem' }}>
          These credentials will allow the wizard to fetch map data and sync it to your React Mobile account.
        </p>
      </div>

      <div>
        <label>
          Map ID
          <input
            {...register('mapId')}
            placeholder="e.g., 67f59ad80b03ee000b42fdb4"
            required
            style={{ display: 'block', width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
          />
        </label>
      </div>

      <div>
        <label>
          API Key
          <input
            {...register('apiKey')}
            placeholder="Enter your Mappedin API key"
            required
            style={{ display: 'block', width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
          />
        </label>
      </div>

      <div>
        <label>
          API Secret
          <input
            {...register('apiSecret')}
            placeholder="Enter your Mappedin API secret"
            required
            style={{ display: 'block', width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
          />
        </label>
      </div>

      <div style={{ marginTop: '1rem' }}>
        <button
          onClick={goBack}
          style={{
            marginTop: '1rem',
            padding: '0.5rem 1.25rem',
            marginRight: '1rem',
            backgroundColor: '#ddd',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          ← Back
        </button>

        <button
          type="submit"
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#29a096',
            color: 'white',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Continue
        </button>
      </div>
    </form>
  )
}
